import React, { ReactElement, useEffect, useState } from "react";
import styled from "styled-components";

interface IProps {
  tip: ReactElement;
}
const InputLock = ({ tip }: IProps) => {
  const [onhover, setHover] = useState(false);

  useEffect(() => {
    if (onhover) {
      setTimeout(() => {
        setHover(false);
      }, 5000);
    }
  }, [onhover]);
  return (
    <Container>
      <TipContainer hover={onhover ? "true" : "false"}>{tip}</TipContainer>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        onMouseEnter={() => setHover(true)}
      >
        <path
          d="M1 8C1 6.5858 1 5.8787 1.43934 5.43935C1.87868 5 2.58579 5 4 5H8C9.4142 5 10.1213 5 10.5606 5.43935C11 5.8787 11 6.5858 11 8C11 9.4142 11 10.1213 10.5606 10.5606C10.1213 11 9.4142 11 8 11H4C2.58579 11 1.87868 11 1.43934 10.5606C1 10.1213 1 9.4142 1 8Z"
          stroke="#131313"
          stroke-width="0.75"
        />
        <path
          d="M6 9C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9Z"
          stroke="#131313"
          stroke-width="0.75"
        />
        <path
          d="M3 5V4C3 2.34315 4.34315 1 6 1C7.65685 1 9 2.34315 9 4V5"
          stroke="#131313"
          stroke-width="0.75"
          stroke-linecap="round"
        />
      </svg>
    </Container>
  );
};

export default InputLock;

const Container = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #fed998;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  position: relative;
`;

const TipContainer = styled.div<{ hover: string }>`
  position: absolute;
  bottom: calc(100% + 0.5rem);
  right: calc(100% - 1rem);
  cursor: default;
  opacity: ${(props) => (props.hover === "true" ? "1" : "0")};
  transition: all ease-in 0.1s;
  z-index: ${(props) => (props.hover === "true" ? "1" : "0")};
`;
